// Bridges AudioContext's `language` state to react-i18next. Mount once
// at the App root. Whenever the user changes the language picker in
// the Header, this effect flips i18next.language so every component
// using `useTranslation()` rerenders in the new locale.
import { useEffect } from "react";
import i18n from "../lib/i18n";
import { useAudio } from "../context/AudioContext";

export default function I18nLanguageSync() {
  const { language } = useAudio();
  useEffect(() => {
    if (!language) return;
    try {
      // Normalize "es-ES" / "es-419" → "es". The dictionary keys use
      // bare ISO codes plus "zh-CN" specifically (full locale because
      // simplified and traditional Chinese diverge).
      const code = language === "zh-CN" ? "zh-CN" : language.toLowerCase().split("-")[0];
      if (i18n.language !== code) i18n.changeLanguage(code);
    } catch (_) {}
  }, [language]);
  return null;
}
